import styled from 'styled-components';
import { LoadingTheme } from '.';
import { NewStyleColor } from '../../utils/styles-constants';
import { spin } from '../../utils/style';

interface StyledSplashscreenProps {
	shouldDisplay: boolean;
	loadingTheme: LoadingTheme;
}

export const StyledSplashscreen = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 5;
	padding: 20px;
	background: ${(props: StyledSplashscreenProps) => props.loadingTheme.background};
	color: ${(props: StyledSplashscreenProps) => props.loadingTheme.color};
	transition: opacity 0.5s;
	${(props: StyledSplashscreenProps) =>
		props.shouldDisplay ?
			`opacity: 1;`
		:
			`opacity: 0;
			pointer-events: none;
			`
	}

	& > img {
		width: 100%;
		max-width: 300px;
	}
`;

export const LoadingContainer = styled('div')`
	position: absolute;
	left: 0;
	top: 85%;
	width: 100%;
	text-align: center;
`;

export const LoadingRow = styled('div')`
	display: inline-flex;
	align-items: center;
	color: ${NewStyleColor.Grey500};
	font-size: 12px;
	line-height: 16px;

	svg {
		height: 20px;
		width: 20px;
		margin-right: 5px;
		flex-shrink: 0;
		animation: ${spin};
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Splashscreen/styles.ts